import React from 'react';
import { useTabContext } from '@/components/context/TabContext';

const PrevButton = ({ swiperRef }) => {
  const { selectedTab } = useTabContext();

  return (
    <button
      onClick={() => swiperRef.current?.slidePrev()}
      className="slider-button"
    >
      <img loading="lazy" src={`${selectedTab === 'adviser'
        ? '/img/icons/arrow-left.svg'
        : '/img/icons/arrow-narrow-left.svg'} `}
      className="w-4 h-4"
      alt="prev"
      />
    </button>
  );
};

export default PrevButton;
